"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/FIFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_73)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_73`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-2.64001 0H33.36V24H-2.64001V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M33.36 9.07368V14.8772H11.6547V24H5.85121V14.8772H-2.64001V9.07368H5.85121V0H11.6547V9.07368H33.36Z",
					fill: "#2E52B2"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_73`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as FIFlag };
